/* import __COLOCATED_TEMPLATE__ from './compelling-offer-banner.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import templateOnlyComponent from '@ember/component/template-only';

export interface Args {
  discountText: string;
}
interface Signature {
  Args: Args;
}

const CompellingOfferBanner = templateOnlyComponent<Signature>();
export default CompellingOfferBanner;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Signup::Teams::Pricing5::Checkouts::CompellingOfferBanner': typeof CompellingOfferBanner;
    'signup/teams/pricing5/checkouts/compelling-offer-banner': typeof CompellingOfferBanner;
  }
}
